import React from 'react';

const fmt = (iso) => {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch {
    return iso;
  }
};

const StatusPill = ({ row }) => {
  if (row.current_status === 'STORED') {
    return <span className="inline-flex rounded-full bg-emerald-100 text-emerald-800 px-2 py-0.5 text-xs font-medium">Stored · {row.bin_location || '-'}</span>;
  }
  if (row.current_status === 'PENDING_PUT_AWAY') {
    return <span className="inline-flex rounded-full bg-amber-100 text-amber-800 px-2 py-0.5 text-xs font-medium">Waiting for put-away</span>;
  }
  return <span className="inline-flex rounded-full bg-slate-100 text-slate-700 px-2 py-0.5 text-xs font-medium">{row.current_status || '-'}</span>;
};

export const HistoryCard = ({ row }) => (
  <div className="bg-white rounded-xl border border-[#E5DFD0] p-3 space-y-1" data-testid={`fc-history-card-${row.new_bundle_code}`}>
    <div className="flex items-start justify-between gap-2">
      <span className="font-mono text-sm font-medium">{row.new_bundle_code}</span>
      <StatusPill row={row} />
    </div>
    <p className="text-xs text-[#5A5F6E]"><span className="font-mono">{row.sku_code}</span> · {row.design_name || '-'}{row.shade ? ` · ${row.shade}` : ''}</p>
    <p className="text-xs"><b>{row.usn_count}</b> pcs from {(row.source_bundles || []).length} bundle(s) · {row.performed_by_name || row.performed_by}</p>
    <p className="text-[11px] text-[#5A5F6E]">{fmt(row.created_at)}</p>
  </div>
);

export const HistoryRow = ({ row }) => {
  const src = row.source_bundles || [];
  return (
    <tr className="border-t border-[#EFE9DC] hover:bg-[#FFFBF5] transition-colors" data-testid={`fc-history-row-${row.new_bundle_code}`}>
      <td className="px-3 py-2 whitespace-nowrap">{fmt(row.created_at)}</td>
      <td className="px-3 py-2 font-mono font-medium">{row.new_bundle_code}</td>
      <td className="px-3 py-2">
        <p className="font-mono text-xs">{row.sku_code}</p>
        <p className="text-xs text-[#5A5F6E]">{row.design_name || '-'}{row.shade ? ` · ${row.shade}` : ''}</p>
      </td>
      <td className="px-3 py-2 font-semibold">{row.usn_count}</td>
      <td className="px-3 py-2 text-xs" title={src.map((s) => `${s.bundle_code} (${s.count})`).join(', ')}>
        {src.slice(0, 2).map((s) => <p key={s.bundle_code} className="font-mono">{s.bundle_code} <span className="text-[#5A5F6E]">×{s.count}</span></p>)}
        {src.length > 2 && <p className="text-[#5A5F6E]">+{src.length - 2} more</p>}
      </td>
      <td className="px-3 py-2 text-xs">{row.performed_by_name || row.performed_by}</td>
      <td className="px-3 py-2"><StatusPill row={row} /></td>
    </tr>
  );
};
